<template>
<div class="chapter">
<div class="inner_page">
<h1>Sommario</h1>
<p><span href="#/c001" title="Link target outside of Sample">Titolo Pagina</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Copyright Pagina</span></p>
<p><a href="#/c003">Presa da due bagnini</a></p>
<p><a href="#/c004">Licenza di utilizzo</a></p>
<p><a href="#/c005">Nota dell'autrice</a></p>
<p><a href="#/c006">Capitolo Uno</a></p>
<p><span href="#/c007" title="Link target outside of Sample">Capitolo Due</span></p>
<p><span href="#/c008" title="Link target outside of Sample">Capitolo Tre</span></p>
<p><span href="#/c009" title="Link target outside of Sample">Capitolo Quattro</span></p>
<p><span href="#/c010" title="Link target outside of Sample">Capitolo Cinque</span></p>
<p><span href="#/c011" title="Link target outside of Sample">Catalogo Jasmine Black Libri Italiani</span></p>
<p><span href="#/c012" title="Link target outside of Sample">Catalogo Jan Springer Libri Italiani</span></p>
<p><span href="#/c013" title="Link target outside of Sample">Altri modi per entrare in contatto:</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?70d9d079